// extracted by mini-css-extract-plugin
export default {"wrapper":"ProposalShape_wrapper__Gji3L","shape":"ProposalShape_shape__VLmAf"};